import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from 'src/app/shared/component/confirmation-popup/confirmation-popup.component';
import { Context } from 'src/app/shared/models/context';
import { Message, Payment, PrivilegeType, Salary } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { PaymentCrudComponent } from '../payment-crud/payment-crud.component';
import { SalarySlipComponent } from '../salary-slip/salary-slip.component';
import { DueCheckComponent } from '../due-check/due-check.component';

@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.scss'],
})
export class PaymentListComponent implements OnInit {
  @Input() salary: Salary;
  public payments: Payment[] = [];
  public payment: Payment;
  public context: Context;
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  public fromDate: string;
  public toDate: string;
  public date: string;
  public sid: number;
  private subscription: any;
  public salaryDate: string;
  public dueCheck:boolean;


  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private employeeService: EmployeeService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private datePipe: DatePipe

  ) { }

  ngOnInit(): void {
    this.privilege = this.commonService.getPrivileges('DELETE');
    // this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.route.queryParams.subscribe(params => {
      if (params) {
        this.sid = params['sid'] || this.sid;
        this.salary = params['salary'];
        
        if (params['fromDate']) {
          this.fromDate = this.datePipe.transform(params['fromDate'], 'yyyy-MM-dd');
        }
        if (params['toDate']) {
          this.toDate = this.datePipe.transform(params['toDate'], 'yyyy-MM-dd');
        }
      }
    });
    this.subscription = this.authService.getContext().subscribe(context => {
      if (context?.employeeId) {
        this.context = context;
        this.getPayments();
      }
    });

    this.dueStatusCheck();

  }

  public onDateChange(event: any): void {
      const selectedDate = event.target ? event.target.value : null; 
      if (selectedDate) {
        this.salaryDate = selectedDate;
          this.employeeService.dueCheck(this.sid, selectedDate).subscribe({
          next: (dueCheck) => {
            this.dueCheck = dueCheck;
          },
          error: (err) => {
          }
        });
      }
    }

  private dueStatusCheck(){
    const today = new Date();
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const date = this.datePipe.transform(lastDayOfMonth, 'yyyy-MM-dd');
    this.salaryDate = date;
    this.employeeService.dueCheck(this.sid, date).subscribe({
      next: (dueCheck) => {
       this.dueCheck=dueCheck;
       this.date = date;
      }
    });
  }

  private getPayments(clear: boolean = true) {
    if (this.context?.employeeId) {
      if (clear) {
        this.isLoading = true;
        this.payments = [];
      }
      if (!this.fromDate || !this.toDate) {
        this.commonService.setToastr(500, "Both \"From Date\" and \"To Date\" are required to proceed.")
        return;
      }
      const fromDate = this.datePipe.transform(this.fromDate, 'dd-MM-yyyy');
      const toDate = this.datePipe.transform(this.toDate, 'dd-MM-yyyy');
      this.employeeService.getPayments(this.context.employeeId, this.sid, fromDate, toDate).subscribe({
        next: (payments: Payment[]) => {
          this.payments = payments.sort((a, b) => {
            return (b.date ? 1 : 0) - (a.date ? 1 : 0);
          });
          // this.payments = payments.sort((a, b) => a.id - b.id)
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.isLoading = false;
    }
  }

  public deletePayment(payment: Payment, index: number) {
    if (!this.privilege.canDelete) return;
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.payment = "Payment deletion";
    modalRef.componentInstance.prefixMessage = "Are you sure you want to delete payment";
    modalRef.componentInstance.message = payment.paymentMode;
    modalRef.componentInstance.label = 'payment';
    modalRef.result.then((isConfirmed: boolean) => {
      if (isConfirmed) {
        payment.isDeleteInProgress = true;
        this.employeeService.deletePayment(payment.id).subscribe({
          next: (message: Message) => {
            if (!message.failed) {
              this.commonService.setToastr(200, message.text);
              this.payments.splice(index, 1);
              this.getPayments(false);
              payment.isDeleteInProgress = false;
            } else {
              this.commonService.setToastr(500, message.text);
              payment.isDeleteInProgress = false;
            }
          },
          error: (error: HttpErrorResponse) => {
            this.commonService.setToastr(500, error?.error?.name || error.error);
            payment.isDeleteInProgress = false;
          },
        });
      }
    });
  }
  public upsertDue(payment: Payment) {
    if (!this.privilege.canEdit) return;
    if (payment){
      if (payment.status == 'DUE' && payment.id) {
        this.employeeService.getPayment(payment.id).subscribe({
          next: (payment : Payment) => {
            this.payment = payment;
            const modalRef = this.modalService.open(PaymentCrudComponent, {size: 'lg', backdrop: 'static'});
            modalRef.componentInstance.payment = this.payment;
            modalRef.componentInstance.sid = this.sid;
            modalRef.componentInstance.salaryDate = this.salaryDate;
            modalRef.result.finally(() => {
              this.getPayments();
            });
          },
          error: (error: HttpErrorResponse) => {
            this.commonService.setToastr(500, error?.error.name || error.error);
          }
        })  
      }
    }
  }
  public upsertPayment(payment?: Payment) {    
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(PaymentCrudComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.payment = payment;
    modalRef.componentInstance.context = this.context;
    modalRef.componentInstance.sid = this.sid;
    modalRef.componentInstance.salaryDate = this.salaryDate;
    modalRef.componentInstance.fromDate = this.fromDate;
    modalRef.componentInstance.toDate = this.toDate;
    modalRef.componentInstance.payments = this.payments.filter(t => t.id !== payment?.id);
    modalRef.result.then((response: Payment) => {
      if (response) {
        this.getPayments(false);
      }
    })
  }

  public processPayment(payment?: Payment) {    
    if (!this.privilege.canEdit) return;
    this.salaryDate = payment.date;
    let modalRef = this.modalService.open(SalarySlipComponent, {size: 'xl', backdrop: 'static',});
    modalRef.componentInstance.paymentId = payment.id;
    modalRef.componentInstance.salaryDate = this.salaryDate;
    modalRef.result.then((response: Payment) => {
    })
      .catch((error) => {
      });
  }

  public onPaymentChange() {
    this.getPayments(false);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  public upsertDueCheck(payment: Payment) {    
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(DueCheckComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.payment = payment;
    modalRef.componentInstance.sid=this.sid;
    modalRef.componentInstance.date=this.date;
    modalRef.result.finally(() => {
      this.getPayments();
      this.dueStatusCheck();
    });
  }
}
